__turbopack_context__.v({
  "description": "GiftBenefit-module-scss-module__mR8VfW__description",
  "imageWrap": "GiftBenefit-module-scss-module__mR8VfW__imageWrap",
  "title": "GiftBenefit-module-scss-module__mR8VfW__title",
  "wrapper": "GiftBenefit-module-scss-module__mR8VfW__wrapper",
});
